<h1>Partidas</h1>
<div class="container">
  <form [formGroup]="filterColumForm" class="form">
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label> Filtro Específico </mat-label>
      <mat-select formControlName="filterDetails" (selectionChange)="cleanFilter()"
        matTooltip="Filtro por una columna de la tabla" matTooltipPosition="above">
        <mat-option value="0">Seleccione...</mat-option>
        <mat-option value="lineItemGrouping" matTooltip="Filtro por la columna Agrupación"
          matTooltipPosition="right">Agrupación
        </mat-option>
        <mat-option value="description" matTooltip="Filtro por la columna Descripción" matTooltipPosition="right">Descripción
        </mat-option>
        <mat-option value="reference" matTooltip="Filtro por la columna Referencia" matTooltipPosition="right">Referencia
        </mat-option>
        <mat-option value="code" matTooltip="Filtro por la columna Código" matTooltipPosition="right">Código</mat-option>
      </mat-select>
      </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always" matTooltip="Valor a filtrar por columna seleccionada"
      matTooltipPosition="above" class="input-width-28vw">
      <mat-label>Valor</mat-label>
      <input matInput placeholder="Valor a filtrar..." formControlName="descriptionFilter" (keyup)="resetPaginator($event)"
        #input2>
      <mat-error *ngIf="filterColumForm.controls['descriptionFilter'].hasError('minlength')">Mínimo 3
        caracteres.</mat-error>
      <mat-error *ngIf="filterColumForm.controls['descriptionFilter'].hasError('maxlength')">Máximo 100
        caracteres.</mat-error>
    </mat-form-field>
    <button mat-raised-button color="primary" type="button" (click)="applyFilterDetails()"
      [disabled]="disableButtonfilter">Filtrar</button>
    </form>
<div class="espacio-div-20"></div>
<form [formGroup]="filterSearchForm" class="form" fxHide.xs fxHide.sm fxHide.md>
  <mat-form-field appearance="outline" floatLabel="always" matTooltip="Filtro por cualquier columna de la tabla"
    matTooltipPosition="above" class="input-width-28vw">
    <mat-label> Filtro General </mat-label>
    <input matInput placeholder="Valor a filtrar..." formControlName="descriptionSearch" (keyup)="resetPaginator($event)"
      #input>
    <mat-error *ngIf="filterSearchForm.controls['descriptionSearch'].hasError('minlength')">Mínimo 3 caracteres.</mat-error>
    <mat-error *ngIf="filterSearchForm.controls['descriptionSearch'].hasError('maxlength')">Máximo 100
      caracteres.</mat-error>
    </mat-form-field>
    <button mat-raised-button color="primary" type="button" (click)="applyFilter()"
      [disabled]="disableButtonSearch">Filtrar</button>
    </form>
</div>
<div class="espacio-div-20" fxHide.lg fxHide.xl></div>
<div class="table-overflow-100">
  <table mat-table [dataSource]="dataSourceFilters" matSort matSortActive="reference" matSortDirection="asc"
    matSortDisableClear class="mat-elevation-z8">
    <ng-container matColumnDef="reference">
      <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Referencia </th>
      <td mat-cell *matCellDef="let element" align="center"> {{element.reference}} </td>
    </ng-container>
    <ng-container matColumnDef="code">
      <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Código </th>
      <td mat-cell *matCellDef="let element"> {{element.code}} </td>
    </ng-container>
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Descripción </th>
      <td mat-cell *matCellDef="let element"> {{element.description}} </td>
    </ng-container>
    <ng-container matColumnDef="unit">
      <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Und. </th>
      <td mat-cell *matCellDef="let element" align="center"> {{element.unit}} </td>
    </ng-container>
    <ng-container matColumnDef="lowPerformance">
      <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Rendimiento </th>
      <td mat-cell *matCellDef="let element"> {{element.lowPerformance | number:'1.6-6':'es'}} </td>
    </ng-container>
    <ng-container matColumnDef="lineItemGrouping">
      <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Agrupación </th>
      <td mat-cell *matCellDef="let element"> {{element.lineItemGrouping}} </td>
    </ng-container>
    <!-- <ng-container matColumnDef="fecha">
      <th mat-header-cell *matHeaderCellDef> Fecha </th>
      <td mat-cell *matCellDef="let element"> {{element.updateDate | date:'shortDate'}} </td>
    </ng-container>
    <ng-container matColumnDef="clasificacion">
      <th mat-header-cell *matHeaderCellDef> Clasificación </th>
      <td mat-cell *matCellDef="let element"> {{element.rating}} </td>
    </ng-container> -->

    <tr mat-header-row *matHeaderRowDef="displayedColumns" class="mat-header-medium"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="verResumenPartida(row)"
      (dblclick)="verDetallePartida(row)"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="8">No hay data que filtrar</td>
    </tr>
  </table>
</div>
<mat-paginator #paginator [length]="totalItemsPage" [pageSizeOptions]="[25, 50, 100]"
  showFirstLastButtons></mat-paginator>
<div class="espacio-div"></div>
<div [ngClass]="classFlag ? 'div-float-mobile' : 'div-float'">
  <mat-accordion>
    <mat-expansion-panel [(expanded)]="xpandStatus" [disabled]="xpandDisabled">
      <mat-expansion-panel-header class='my-expansion-panel-header specific-class'>
        <mat-panel-title>
          APU Referencia: {{ referenciaPartida }}
        </mat-panel-title>
        <mat-panel-description>
          Precio Unitario: {{ precioUnitario | number: '1.2-2':'es' }}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <br>
      <h4><strong>Costo Unit. Materiales: {{ costoUnicoMateriales | number: '1.2-2':'es' }}</strong></h4>
      <div style="overflow-y:auto; overflow-x:auto; max-height: 150px; max-width: 550px;">
        <table mat-table [dataSource]="dataSourceMaterial" class="mat-elevation-z8">
          <ng-container matColumnDef="reference">
            <th mat-header-cell *matHeaderCellDef style="width: 10%;" class="mat-header-cell-datalaing"> Referencia </th>
            <td mat-cell *matCellDef="let element" align="center"> {{element.referenceMaterial}} </td>
            <!-- <mat-footer-cell *matFooterCellDef></mat-footer-cell> -->
          </ng-container>
          <ng-container matColumnDef="description">
            <th mat-header-cell style="width: 40%;" *matHeaderCellDef class="mat-header-cell-datalaing"> Descripción </th>
            <td mat-cell *matCellDef="let element"> {{element.materialDescription}} </td>
            <!-- <mat-footer-cell *matFooterCellDef></mat-footer-cell> -->
          </ng-container>
          <ng-container matColumnDef="unit">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Unid. </th>
            <td mat-cell *matCellDef="let element"> {{element.materialUnit}} </td>
            <!-- <mat-footer-cell *matFooterCellDef></mat-footer-cell> -->
          </ng-container>
          <ng-container matColumnDef="quantity">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Cant. </th>
            <td mat-cell *matCellDef="let element" align="right"> {{ element.materialQuantity | number: '1.4':'es' }} </td>
            <!-- <mat-footer-cell *matFooterCellDef></mat-footer-cell> -->
          </ng-container>
          <ng-container matColumnDef="waste">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Desp. </th>
            <td mat-cell *matCellDef="let element" align="right"> {{ element.wasteMaterial | number: '1.1':'es' }} </td>
            <!-- <mat-footer-cell *matFooterCellDef></mat-footer-cell> -->
          </ng-container>
          <ng-container matColumnDef="price">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Precio </th>
            <td mat-cell *matCellDef="let element" align="right"> {{element.priceMaterial | number: '1.2':'es' }} </td>
            <!-- <mat-footer-cell *matFooterCellDef></mat-footer-cell> -->
          </ng-container>
          <ng-container matColumnDef="total">
            <th mat-header-cell align="center" *matHeaderCellDef class="mat-header-cell-datalaing"> Total </th>
            <td mat-cell align="right" *matCellDef="let element"> {{element.materialTotalPrice | number: '1.2':'es' }}
            </td>
            <!-- <mat-footer-cell style="text-align: right">Total: 252336652</mat-footer-cell> -->
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumnsMaterial" class="mat-header-medium"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsMaterial;"></tr>
          <!-- <mat-footer-row class="sticky-footer" *matFooterRowDef="['total']"></mat-footer-row> -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="7">No aplica materiales para esta partida</td>
          </tr>
        </table>
      </div>
      <br>
      <h4><strong>Costo Unit. Equipos: {{ costoUnicoEquipo | number: '1.2-2':'es' }}</strong></h4>
      <div style="overflow-y:auto; overflow-x:auto; max-height:150px; max-width: 550px;">
        <table mat-table [dataSource]="dataSourceEquipo" class="mat-elevation-z8">
          <ng-container matColumnDef="reference">
            <th mat-header-cell *matHeaderCellDef style="width: 10%;" class="mat-header-cell-datalaing"> Referencia </th>
            <td mat-cell *matCellDef="let element" align="center"> {{element.equipmentReference}} </td>
          </ng-container>
          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef style="width: 40%;" class="mat-header-cell-datalaing"> Descripción </th>
            <td mat-cell *matCellDef="let element"> {{element.equipmentDescription}} </td>
          </ng-container>
          <ng-container matColumnDef="quantity">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Cant. </th>
            <td mat-cell *matCellDef="let element" align="right"> {{element.quantityEquipment | number: '1.2':'es'}} </td>
          </ng-container>
          <ng-container matColumnDef="waste">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> COP/Dep. </th>
            <td mat-cell *matCellDef="let element" align="right"> {{element.depreciationEquipment | number: '1.6':'es'}} </td>
          </ng-container>
          <ng-container matColumnDef="price">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Precio </th>
            <td mat-cell *matCellDef="let element" align="right"> {{element.priceEquipment | number: '1.2':'es'}} </td>
          </ng-container>
          <ng-container matColumnDef="total">
            <th mat-header-cell *matHeaderCellDef align="center" class="mat-header-cell-datalaing"> Total </th>
            <td mat-cell *matCellDef="let element" align="right"> {{element.equipmentTotalPrice | number: '1.2':'es'}} </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumnsEquipos" class="mat-header-medium"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsEquipos;"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="6">No aplica equipos para esta partida</td>
          </tr>
        </table>
      </div>
      <br>
      <h4><strong>Costo Unit. Mano de Obra: {{ costoUnicoManoDeObra | number: '1.2-2':'es' }} / % FCAS: {{ porcPrestacionesManoDeObra }}</strong></h4>
      <div style="overflow-y:auto; overflow-x:auto; max-height:150px; max-width: 550px;" class="mat-elevation-z8">
        <table mat-table [dataSource]="dataSourceManosObra" class="mat-elevation-z8">
          <ng-container matColumnDef="reference">
            <th mat-header-cell *matHeaderCellDef style="width: 10%;" class="mat-header-cell-datalaing"> Referencia </th>
            <td mat-cell *matCellDef="let element" align="center"> {{element.laborReference}} </td>
          </ng-container>
          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef style="width: 40%;" class="mat-header-cell-datalaing"> Descripción </th>
            <td mat-cell *matCellDef="let element"> {{element.laborDescription}} </td>
          </ng-container>
          <ng-container matColumnDef="quantity">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Cant. </th>
            <td mat-cell *matCellDef="let element" align="right"> {{element.quantityLabor | number: '1.2':'es'}} </td>
          </ng-container>
          <ng-container matColumnDef="jornal">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Jornal </th>
            <td mat-cell *matCellDef="let element" align="right"> {{element.jornalLabor | number: '1.2':'es'}} </td>
          </ng-container>
          <ng-container matColumnDef="bono">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Bono </th>
            <td mat-cell *matCellDef="let element" align="right"> {{element.priceLabor | number: '1.2':'es'}} </td>
          </ng-container>
          <ng-container matColumnDef="totalbono">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Total Bono </th>
            <td mat-cell *matCellDef="let element" align="right"> {{element.laborTotalBonus | number: '1.2':'es'}} </td>
          </ng-container>
          <ng-container matColumnDef="totaljornal">
            <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Total Jornal </th>
            <td mat-cell *matCellDef="let element" align="right"> {{element.laborTotalJornal | number: '1.2':'es'}} </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumnsManoObras" class="mat-header-medium"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsManoObras;"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="6">No aplica mano de obra para esta partida</td>
          </tr>
        </table>
      </div>
      <br>
      <div class="container-fluid cew-9">
        <div class="row">
          <div class="col-7">
            <!--div class="row"-->
            <div class="mat-table" style="text-align: right;align-items:right;">
              <table class="mat-elevation-z8">
                <tbody>
                  <tr>
                    <th colspan="2" align="left" class="mat-header-cell" style="text-align: left !important;">
                      Costo Directo SubTotal A: <strong>{{costoDirectoSubTotalA | number: '1.2-2':'es'}}</strong>
                    </th>
                  </tr>
                  <tr>
                    <th colspan="2" align="left" class="mat-header-cell" style="text-align: left !important;">
                      <span style="white-space: pre-line">
                        %Admin.: <strong>{{gastosGeneralesAdmin | number: '1.2-2':'es'}}</strong> %Util.: <strong>{{utilidadesImprevisto| number: '1.2-2':'es'}}</strong> %O. Imp.: <strong>0,00</strong>
                      </span>
                      <span style="white-space: pre-line">
                        %Finan.: <strong>{{financiamiento| number: '1.2-2':'es'}}</strong> %IVA: <strong>{{montoImpuestoIva| number: '1.2-2':'es'}}</strong>
                      </span>
                    </th>
                  </tr>
                  <tr>
                    <th colspan="2" align="left" class="mat-header-cell" style="text-align: left !important;">
                      Números de Trabajadores: <strong>{{totalTrabajadores}}</strong>
                    </th>
                  </tr>
                  <tr>
                    <th colspan="2" align="left" class="mat-header-cell" style="text-align: left !important;">
                      Números de Horas Trabajadas: <strong>{{workingHour}}</strong>
                    </th>
                  </tr>
                  <tr>
                    <th colspan="2" align="left" class="mat-header-cell" style="text-align: left !important;">
                      Números de HH al Día: <strong>{{workingHourDay | number:'1.2-2':'es'}}</strong>
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
            <!--/div-->
          </div>
          <div class="col">
            <strong>Descripción: </strong> {{ descripcionPartida }}
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
